import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, forwardRef } from '@chakra-ui/react';
export const TimelineContent = forwardRef((props, ref) => {
    return _jsx(Flex, { ref: ref, flex: 1, ...props });
});
